import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MdButtonComponent } from './md-button/md-button.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MdCheckboxComponent } from './md-checkbox/md-checkbox.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MdInputSearchComponent } from './md-input-search/md-input-search.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { MdInputAutocompleteComponent } from './md-input-autocomplete/md-input-autocomplete.component';
import { MdSelectComponent } from './md-select/md-select.component';
import { ExamplesComponent } from './examples/examples.component';
import { MdIconButtonComponent } from './md-icon-button/md-icon-button.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    ExamplesComponent,
    MdButtonComponent,
    MdCheckboxComponent,
    MdInputSearchComponent,
    MdInputAutocompleteComponent,
    MdSelectComponent,
    MdIconButtonComponent,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    TranslateModule,
    PerfectScrollbarModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    MdButtonComponent,
    MdCheckboxComponent,
    MdInputSearchComponent,
    MdInputAutocompleteComponent,
    MdSelectComponent,
    ExamplesComponent
  ],
})
export class MeddataThemeModule {}
